<template>
  <a-card :bordered="false" class="m-t-10">
    <p class="fz-16 s_font_b p-b-20">
      <a-button class="m-r-10" size='small' @click="()=>{$router.go(-1)}">
        <LeftOutlined />返回
      </a-button>
      创建出库单
    </p>
    <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-item label="出库类型" name='out_warehousing_type'>
        <a-radio-group v-model:value="form.out_warehousing_type" @change='radioChange'>
          <a-radio :value="1">出库给直属经销商</a-radio>
          <a-radio :value="2">出库给直属门店</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item :label="form.out_warehousing_type ==1 ? '经销商名称':'门店名称'" name='out_warehousing_to_id'>
        <a-input :placeholder="form.out_warehousing_type == 1 ? '请选择经销商':'请选择门店'" style="width: 380px;margin-right: 10px;"
          readonly v-model:value="form.out_warehousing_to_name"></a-input>
        <a-button type="primary" @click="openStoreSelect">选择{{form.out_warehousing_type == 1 ? '经销商':'门店'}}</a-button>
      </a-form-item>
      <a-form-item label="发货仓库" name='warehouse_id'>
        <a-select v-model:value="form.warehouse_id" style='width: 40%;' placeholder="请选择发货仓库">
          <a-select-option v-for='item in warehouseList' :key='item.id' :value="item.id">{{item.name}}
          </a-select-option>
        </a-select>
      </a-form-item>
    
    
      <a-form-item label="订单备注" name='remark'>
        <a-textarea v-model:value="form.remark" style='width: 40%;' placeholder="请输入订单备注" :rows="4" :maxlength='100' />
      </a-form-item>
           <a-form-item label="出库方式" name="" >
        <a-radio-group v-model:value="form.use_product_batch" @change='radioChange' :disabled="isDisabled">
          <a-radio :value="0">商品出库</a-radio>
          <a-radio :value="1">批次出库</a-radio>
        </a-radio-group>
      </a-form-item>
      <!-- <a-form-item label='生产批次' v-if='form.use_product_batch == 1' name='product_batch_id'>
        <a-input style="width: 480px;margin-right: 10px;" readonly v-model:value="form.product_batch_name" placeholder='请选择生产批次'></a-input>
        <a-button type="primary" @click="showBatch = true" :disabled="isDisabled">选择</a-button>
      </a-form-item> -->
      <a-form-item label="商品" name='goodList' v-if="form.use_product_batch==0">
        <a-button type="primary" @click='showGood = true'><PlusOutlined />添加商品</a-button>
        <a-table class='m-t-20' :pagination='false' :loading='loading' bordered rowKey='product_sn' :columns='columns'  :data-source='goodList'>
          <template v-slot:gift_name="{ record }">
            <a-card-meta>
              <template #avatar>
                <img :src="info.picdomain+'/'+(record.product_image)" alt="" style="width:50px;height:50px">
              </template>
              <template #description>
                <p class="s_omit2" style="width: 320px;">{{record.product_name}}</p>
              </template>
            </a-card-meta>
          </template>
          <template v-slot:num="{ record }">
            <a-input-number style='width: 100%;' v-model:value="record.num" :precision='0' :min='1' placeholder='请输入数量' />
            <p v-if='record.fail' style='color:#ff4d4f'>请输入出库数量！</p>
          </template>
          <template v-slot:action="{ index }">
            <a-button type="link" @click='delGood(index)'>删除</a-button>
          </template>
        </a-table>
      </a-form-item>
            <a-form-item label="商品" name='goodList' v-if="form.use_product_batch==1">
        <a-button type="primary"  @click="showBatch = true" ><PlusOutlined />添加产品批次</a-button>
        <a-table class='m-t-20' :pagination='false' :loading='loading' bordered rowKey='product_sn' :columns='columns_batch'  :data-source='goodList'>
          <template v-slot:gift_name="{ record }">
            <a-card-meta>
              <template #description>
                <p class="s_omit2" style="width: 320px;">{{record.product_name}}</p>
              </template>
            </a-card-meta>
          </template>
          <template v-slot:num="{ record }">
            <a-input-number style='width: 100%;' v-model:value="record.num" :precision='0' :min='1' placeholder='请输入数量' />
            <p v-if='record.fail' style='color:#ff4d4f'>请输入出库数量！</p>
          </template>
          <template v-slot:action="{ index }">
            <a-button type="link" @click='delGood(index)'>删除</a-button>
          </template>
        </a-table>
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 8, offset: 2 }">
        <a-button class="width-100 m-r-20" block @click="()=>{$router.go(-1)}">取消</a-button>
        <a-button class="width-100" block type="primary" @click="onSubmit">保存</a-button>
      </a-form-item>
    </a-form>
  </a-card>
  <a-modal :keyboard="false" title="选择门店" v-model:visible="showStore" centered :width='1300' :footer="null"
    destroyOnClose>
    <selectStore :checkout='false' v-on:select="storeSelect" :selectList='[{id:form.out_warehousing_to_id}]' :hiddenHead='true'>
    </selectStore>
  </a-modal>
  <a-modal :keyboard="false" title="选择经销商" centered v-model:visible="showDealer" :width='1300' :footer="null"
    destroyOnClose>
    <selectDealer :checkout='false' v-on:select="storeSelect" :selectList='[{id:form.out_warehousing_to_id}]'></selectDealer>
  </a-modal>
  <a-modal :keyboard="false" title="选择商品" v-model:visible="showGood" centered :width='1300' :footer="null" destroyOnClose>
    <warehousingGoods v-on:select="goodSelect" :selectList='goodList' :checkout="true"></warehousingGoods>
  </a-modal>
    <a-modal  :keyboard="false" title="选择生产批次" v-model:visible="showBatch" centered :width='1300' :footer="null" destroyOnClose>
    <selectGoodBatch v-on:select="batchSelect"  :checkout="true" :selectList="goodList"></selectGoodBatch>
  </a-modal>
</template>

<script>
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { LeftOutlined,PlusOutlined } from "@ant-design/icons-vue";
  import { message } from "ant-design-vue";
  import { addOutWarehousing,getWarehouseList } from '@/api/antiFleeing';
  import { iscode } from "@/utils/app";
  import store from "@/store";
  import warehousingGoods from '../../components/warehousingGoods.vue';
  import selectStore from '../../warehouseOut/components/selectStore.vue' 
  import selectDealer from '../../warehouseOut/components/selectDealer.vue' 
  let defForm = {
    out_warehousing_type: 1,
    out_warehousing_to_id: '',
    warehouse_id: null,
    product: [],
    remark:'',
    product_batch_id:'',
    use_product_batch:0
  };
  export default {
    components: { LeftOutlined,PlusOutlined,warehousingGoods,selectStore,selectDealer},
    setup() {
      const ruleForm = ref();
      const form = ref({ ...defForm });
      let goodList = async () => {
        if (!state.goodList.length) {
          return Promise.reject('请选择商品!');
        } else {
          return Promise.resolve();
        }
      };
      const state = reactive({
        showBatch:false,
        warehouseList:[],
        labelCol: {span: 2},
        wrapperCol: {span: 22},
        info: store.state.user.info,
        showStore: false,
        showDealer: false,
        showGood:false,
        goodList: [],
        loading:false,
        rules: {
          out_warehousing_type: [
            { required: true, message: '请选择出库类型',type:'number'}
          ],
          out_warehousing_to_id: [
            { required: true, message: form.value.out_warehousing_type == 1? '请选择经销商':'请选择门店',type:'number'}
          ],
          warehouse_id: [
            { required: true, message: '请选择发货仓库',type:'number'}
          ],
          product_batch_id: [
            { required: true, message: '请选择生产批次',type:'number'}
          ],
          goodList:[
            { required: true, validator: goodList}
          ]
        }
      });
      const columns = [
        {
          title: "商品编码",
          dataIndex: "product_sn",
          key: "product_sn"
        },
        {
          title: "商品信息",
          dataIndex: "gift_name",
          key: "gift_name",
          slots: { customRender: "gift_name" },
        },
        {
          title: "规格",
          dataIndex: "product_sku_name",
          key: "product_sku_name",
          customRender:({record})=>{
            return record.product_sku_name ? record.product_sku_name:'单规格'
          } 
        },
        {
          title: "出货数量",
          dataIndex: "num",
          key: "num",
          slots: { customRender: "num" },
        },
        {
          title: "操作",
          key: "action",
          slots: { customRender: "action" },
        }
      ];
      const columns_batch=[
         {
          title: "商品编码",
          dataIndex: "product_sn",
          key: "product_sn"
        },
        {
          title: "关联商品",
          dataIndex: "gift_name",
          key: "gift_name",
          slots: { customRender: "gift_name" },
        },
        {
          title: "规格",
          dataIndex: "product_sku_name",
          key: "product_sku_name",
          customRender:({record})=>{
            return record.product_sku_name ? record.product_sku_name:'单规格'
          } 
        },
        {
          title: "出货数量",
          dataIndex: "num",
          key: "num",
          slots: { customRender: "num" },
        },
        {
          title: "操作",
          key: "action",
          slots: { customRender: "action" },
        }
      ]
      const $route = inject("$route");
      const $Modal = inject("$Modal");
      const $router = inject("$router");
      const _lodash = inject("_lodash");
      //数字判断
      const  isNumber = (obj) => {
        return !isNaN(parseFloat(obj)) && isFinite(obj);
      }
      // 获取仓库
      const getWarehouse = async () => {
        let res = await getWarehouseList().then(res => res.data);
        if (iscode(res)) {
          state.warehouseList = res.data;
                   // 默认选择默认仓库
          form.value.warehouse_id=res.data[0].id
        } else {
          message.error(res.msg);
        }
      }
      const radioChange = () => {
        // form.value.out_warehousing_to_name = "";
        // form.value.out_warehousing_to_id = "";
        state.goodList=[]

      }
      //打开选择门店/经销商
      const openStoreSelect = () =>{
        if(form.value.out_warehousing_type == 1){
          state.showDealer = true
        }else{
          state.showStore = true
        }
      }
      //选择门店/经销商
      const storeSelect = (e) => {
        // form.value.out_warehousing_to_id = e.id || e.dealer_id;
        // form.value.out_warehousing_to_name = e.store_name || e.dealer_name;
         form.value.out_warehousing_to_id = e.id || '';
        form.value.out_warehousing_to_name = e.name || '';
        state.showStore = false;
        state.showDealer = false
      }
      //选择商品
      const goodSelect = (e) => {
        state.goodList = e
        state.showGood = false
      }
      //删除商品
      const delGood = (index) => {
        state.goodList.splice(index, 1)
      }
      //提交
      const onSubmit = () => {
          form.value.product = []
          state.goodList.forEach(v=>{
            v.fail = false
            if(!isNumber(v.num)){
              v.fail = true
            } 
            if(form.value.use_product_batch==1){
            form.value.product.push(v.product_id+'_'+(v.product_sku_sn?v.product_sku_sn:0)+'_'+(v.num?v.num:0)+'_'+v.id)
            }else{
            form.value.product.push(v.product_id+'_'+(v.product_sku_sn?v.product_sku_sn:0)+'_'+(v.num?v.num:0))

            }
          })
        ruleForm.value.validate().then(() => {
          if(state.goodList.findIndex(v=> v.fail ) !== -1){
            message.error('请输入出库数量!');
            return false
          }
          $Modal.confirm({
            centered: true,
            title: '确认生成出库单？',
            content: '保存后商品信息将无法修改',
            async onOk() {
              const hide = message.loading("正在加载中...", 0);
              let res = await addOutWarehousing({ ...form.value}).then((res) => res.data).catch(error => error);
              if (iscode(res)) {
                message.success(res.msg);
                setTimeout(() => {
                  $router.go(-1);
                }, 2000);
              } else {
                message.error(res.msg);
              }
              setTimeout(hide);
            }
          })
        }).catch(error => {
          message.error('请完善表单！');
        });
      };
           //选择批次
      const batchSelect = (e) =>{
        state.goodList = e
        // var product_name = (e.product_sku_name?e.product_sku_name:'单规格')+' - '+e.product_name
        // form.value.product_batch_id = e.id
        // form.value.product_batch_name = e.batch_name+'('+product_name+')'
        state.showBatch = false
        // form.value.product = [e.product_id+'_'+(e.product_sku_sn?e.product_sku_sn:0)+'_'+(e.num?e.num:0)]
      }
      onMounted(() => {
        getWarehouse();
      });
      return {
        form,
        ruleForm,
        ...toRefs(state),
        columns,
        onSubmit,
        storeSelect,
        goodSelect,
        delGood,
        openStoreSelect,
        radioChange,
        batchSelect,
        columns_batch
      };
    },
  };
</script>